"use strict";

exports.__esModule = true;
exports.CommentsIcon = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var CommentsIcon = exports.CommentsIcon = function CommentsIcon(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    width: props.width,
    height: props.height,
    viewBox: "0 0 48 48"
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    stroke: "currentColor",
    strokeWidth: 3,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.61 40.089c0-1.666-.005-3.336.004-5.001 0-.302-.045-.44-.4-.545-1.876-.572-3.622-1.423-5.153-2.709-1.827-1.532-3.286-3.358-4.31-5.531-.807-1.72-1.4-3.515-1.561-5.432-.072-.855-.22-1.711-.184-2.562.103-2.448.534-4.823 1.562-7.079.951-2.086 2.235-3.903 3.892-5.445 1.871-1.747 4.08-2.891 6.553-3.445 1.055-.233 2.16-.311 3.241-.32 4.274-.037 8.547-.01 12.816-.019 1.818-.004 3.627.124 5.35.732a15.45 15.45 0 0 1 4.454 2.476c1.391 1.103 2.514 2.425 3.456 3.903 1.154 1.816 1.917 3.807 2.34 5.94.336 1.687.399 3.399.264 5.092a17.151 17.151 0 0 1-1.463 5.669c-.916 2.04-2.142 3.857-3.762 5.353-1.75 1.616-3.753 2.814-6.083 3.41-1.45.37-2.917.498-4.403.498-.934 0-1.872-.023-2.801.014-.288.013-.62.128-.835.315-.997.86-1.948 1.776-2.927 2.65-1.522 1.363-3.066 2.708-4.588 4.072-1.005.901-1.988 1.826-2.99 2.732-.367.334-.726.695-1.144.951-.723.449-1.315.078-1.32-.777-.009-1.643-.009-3.29-.009-4.942z",
    fillRule: "nonzero"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.5 14.5h22.09M13.5 22.5h12",
    strokeLinecap: "square"
  })));
};